import {Button, makeStyles, Paper, Typography} from "@material-ui/core";
import {generatePath, Link, useParams} from "react-router-dom";
import {path as cookiePath} from "../../Routes/cookies";
import useSessionStorage from "@postinumero/storage/useSessionStorage";
import messages from "@super-template/messages";
import {FormattedMessage} from "react-intl";

const useStyles = makeStyles((theme) => ({
  cookie: {
    width: 800,
    maxWidth: "100%",
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: theme.spacing(2),
    bottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      bottom: 0,
      borderRadius: 0
    },
    '& p': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    }
  }
}));

export default () => {
  const {organization} = useParams();
  const classes = useStyles();
  const [, setCookie_accepted] = useSessionStorage('cookie_accepted');

  return (
    <Paper elevation={13} className={classes.cookie}>
      <Typography component="label" id={"cookie-label"}>
        <strong><FormattedMessage {...messages.cookies_use} /></strong>
      </Typography>
      <Typography component="p">
        <FormattedMessage {...messages.cookies_accept} />{' '}
        <Link to={generatePath(cookiePath, {organization})}><FormattedMessage {...messages.cookies_read} /></Link>
      </Typography>
      <Button autoFocus variant="contained" color="primary" onClick={() => setCookie_accepted(true)}
              aria-describedby={"cookie-label"}>
        <FormattedMessage {...messages.cookies_accept_btn} />
      </Button>
    </Paper>
  )
}
